
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'MID', value: 'mid'},
  { text: 'Nama Merchant', value: 'merchant_name'},
  { text: 'Sales Volume', value: 'sales_volume'},
  { text: 'Trasaction Date', value: 'date'},
  { text: 'Inputer', value: 'inputer'},
  { text: 'Merchant Category', value: 'merchant_criteria'},
]);


export const search = {
  mid: '',
  created_at: [],
};

